module.exports = __webpack_public_path__ + "static/media/businessman.32d79cca.png";